var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgE2MakeupRoomBis(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M63 46v15.52A3.48 3.48 0 0159.52 65h-5A3.48 3.48 0 0151 61.52V46h12zm-1-6H52v3h10v-3zm-2-17.33l-6 4.66V37h6V22.67zm-13.07 5.14A19 19 0 0130 48.3V61h7v4H19v-4h7V48.3a19 19 0 1120.93-20.49zM43 29.38a15 15 0 10-29.998 0 15 15 0 0029.998 0zM24.67 18.52L23 24.84l-6.32 1.68L23 28.2l1.68 6.32 1.68-6.32 6.32-1.68-6.32-1.68-1.69-6.32z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/E2_Makeup_room_bis.d11dd867.svg";
export { SvgE2MakeupRoomBis as ReactComponent };